<section class="container">
	<lvr-heading class="text-inverse">
		<span
			><mat-icon aria-hidden="true" fontIcon="connect_without_contact"></mat-icon>
			{{ 'network_contact.overview.title' | transloco }}</span
		>
	</lvr-heading>

	<!-- List -->
	<div class="list-container">
		<lvr-simple-panel>
			<div content>
				@if (contacts().length === 0) {
					<p>{{ 'network_contact.overview.no_contacts' | transloco }}</p>
				}
				@for (c of contacts(); track c.id) {
					<a class="link" [routerLink]="['/desk', 'network-contact', c.id]">
						<lvr-contact-card
							[showEdit]="true"
							[showDocuments]="true"
							[showRemarks]="false"
							[contact]="c"
						></lvr-contact-card>
					</a>
				}
			</div>
		</lvr-simple-panel>
	</div>

	<lvr-paginator
		[length]="totalItems()"
		[pageSize]="pageSize()"
		[pageIndex]="pageIndex()"
		[showFirstLastButtons]="showFirstLastButtons"
		[hidePageSize]="hidePageSize"
		preferenceKey="network-contact-overview"
		(page)="handlePageEvent($event)"
	>
	</lvr-paginator>
</section>
